import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class AlertService {
  obj;
  confirmAlert;
  toastObj;
  verifyObj;

  constructor(private toastr: ToastrService) {
    // Toast object init
    this.obj = {
      timeOut: 4000,
      closeButton: true,
      enableHtml: true,
      positionClass: "toast-top-right",
    };

    // confirm alert init (SweetAlert2 v11: use 'icon' not 'type', use customClass for button classes)
    this.confirmAlert = {
      icon: undefined as string | undefined,
      title: '',
      text: '',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      buttonsStyling: true
    };
    this.verifyObj = {
      title: '',
      input: '',
      inputAttributes: { autocapitalize: 'off' },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: '',
      allowOutsideClick: () => !Swal.isLoading()
    };
  }

  /**
  * Verify popup
  * @param title
  * @param input
  * @param preconfirm
  */
  verifyPopup(title, input, preconfirm) {
    this.verifyObj.title = title;
    this.verifyObj.input = input;
    this.verifyObj.preConfirm = preconfirm;
    return Swal.fire(this.verifyObj);
  }

  toastShow(message) {
    this.toastr.show(message, '', {...this.obj, toastClass: 'alert alert-primary alert-with-icon'});
  }

  successToast(message) {
    this.toastr.success(message, '', {...this.obj, toastClass: 'alert alert-success alert-with-icon'});
  }

  errorToast(message) {
    this.toastr.error(message, '', {...this.obj, toastClass: 'alert alert-danger alert-with-icon'});
  }

  simplePopUp(message) {
    this.toastr.info(message, '', {...this.obj, toastClass: 'alert alert-info alert-with-icon'});
  }

  warningPopUp(message) {
    this.toastr.warning(message, '', {...this.obj, toastClass: 'alert alert-warning alert-with-icon'});
  }

  confirmPopUp(obj: { title: string; type?: string; icon?: string; text?: string; html?: string }) {
    this.confirmAlert.title = obj.title;
    // SweetAlert2 v11 uses 'icon', not 'type'
    this.confirmAlert.icon = (obj.icon ?? obj.type) || undefined;
    if (obj.html) {
      this.confirmAlert.html = obj.html;
      delete this.confirmAlert.text;
    } else {
      this.confirmAlert.text = obj.text;
      delete this.confirmAlert.html;
    }
    // Build options without undefined/invalid params so SweetAlert2 doesn't warn or fail
    const opts: any = { ...this.confirmAlert };
    if (opts.icon === undefined || opts.icon === '') delete opts.icon;
    return Swal.fire(opts);
  }

  input(title: string, inputType: 'text' | 'textarea', placeholder?: string, value?: string) {
    return Swal.fire({
      title: title,
      input: inputType,
      inputPlaceholder: placeholder,
      inputValue: value,
      inputAttributes: {
        'aria-label': 'Type your message here'
      },
      showCancelButton: true
    })
  }

//   textArea(title, prevMessage, placeholder) {
//     return Swal.fire({
//       title: title,
//       input: 'text',
//       inputValue: prevMessage,
//       inputPlaceholder: placeholder,
//       showCancelButton: true,
//       inputValidator: (value) => {
//         return new Promise((resolve) => {
//           if (value) {
//             resolve();
//           } else {
//             resolve('Please add comment');
//           }
//         });
//       },
//       customClass: 'required'
//     });
//   }
}
